import * as React from "react";
import Box from "@mui/material/Box";
import { Nav } from "./Elements";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useSelector } from "react-redux";
import { getlogo } from "./navSlice";
import { useNavigate } from "react-router-dom";
import ProfileDropDown from "../../../Global/navbar/ProfileDropDown";

export default function QENavbar() {
  const showLogo = useSelector(getlogo);

  return (
    <Nav>
      <Box sx={{ display: "flex", alignItems: "center", height: "100%", px: "16px" }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {showLogo ? <img src="/assets/tjommie-logo.svg" height="24" alt="Tjommie" style={{ display: "block" }} /> : <Backbutton />}
        </Box>
        <Box sx={{ flex: 1 }} />
        <ProfileDropDown />
      </Box>
    </Nav>
  );
}

function Backbutton() {
  const navigate = useNavigate();
  return (
    <ArrowBackIcon onClick={() => navigate(-1)} sx={{ color: "rgba(255,255,255,0.7)", cursor: "pointer", fontSize: "1.3rem" }} />
  );
}
